import { FC } from 'react';
import { Control } from 'react-hook-form';

import Button from '@/components/Button';
import { FormLayout } from '@/components/Forms';
import FormField from '@/components/Forms/FormField';
import { Modal } from '@/components/Modal';
import SidePanel, {
  SidePanelBody,
  SidePanelContent,
  SidePanelFooter,
} from '@/components/SidePanel';

import { FormDataT } from '..';

interface Props {
  onClose: VoidFunction;
  control: Control<FormDataT>;
  onSubmit: () => Promise<void>;
}

const DetailsDrawer: FC<Props> = ({ onClose, control, onSubmit }) => {
  const handleSubmit = () => {
    onSubmit();
    onClose();
  };

  return (
    <Modal>
      <SidePanel heading="Add Details" onClose={onClose}>
        <SidePanelBody as="div">
          <SidePanelContent>
            <FormLayout>
              <FormField
                control={control}
                name="title"
                label="Compilation Name"
                placeholder="Add name"
              />
              <FormField
                id="watermark"
                label="Watermark"
                control={control}
                // existingMedia={compilation?.watermark}
                name="watermark"
                type="image"
                notes={'PNG only. Image Dimensions must be the same as video'}
                accept="image/png"
              />
            </FormLayout>
          </SidePanelContent>
          <SidePanelFooter $actions>
            <Button type="button" onClick={handleSubmit}>
              Save
            </Button>
            <Button type="button" color="secondary" onClick={onClose}>
              Close
            </Button>
          </SidePanelFooter>
        </SidePanelBody>
      </SidePanel>
    </Modal>
  );
};

export default DetailsDrawer;
